import { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { usePayment } from "../../../../../APIContext/PaymentContext";
import Swal from "sweetalert2";
import "../../../../../Components/AddPlayerProfileModal/modal.css";

const AddCard = ({ onSuccess, setOpen }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { createSetupIntent, syncCard, loading } = usePayment();

  const [processing, setProcessing] = useState(false);

  const handleSaveCard = async () => {
    if (!stripe || !elements) return;

    setProcessing(true);

    //  Create Setup Intent
    const clientSecret = await createSetupIntent();
    if (!clientSecret) {
      setProcessing(false);
      return;
    }

    //  Confirm card setup
    const cardElement = elements.getElement(CardElement);
    const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (error) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.message,
        confirmButtonColor: "#B79527",
        cancelButtonColor: "#1C1C1C",
      });
      setProcessing(false);
      return;
    }

    //  Sync card with backend
    const res = await syncCard(setupIntent.payment_method);
    if (res) {
      Swal.fire({
        icon: "success",
        title: "Card Saved",
        text: "Your card has been added successfully!",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      onSuccess();
      setOpen(false); // close modal
    }

    setProcessing(false);
  };

  return (
    <div className="modal-overlay" onClick={() => setOpen(false)}>
      <div
        className="modal-box bg-custom brightness"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="modal-header">
          <h3 className="text-clip">Add New Card</h3>
        </div>

        {/* Content */}
        <div className="modal-content">
          <div className="modal-row">
            <label className="text-clip">Card Details</label>
            <div
              style={{
                backgroundColor: "white",
                padding: "10px 5px",
                borderRadius: "10px",
                filter: "brightness(0.8)",
              }}
              className="stripe-card-wrapper"
            >
              <CardElement
                options={{
                  style: {
                    base: {
                      fontSize: "16px",
                      color: "#000",
                      "::placeholder": { color: "#999" },
                      padding: "2px 4px",
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="modal-actions">
          <button
            onClick={() => setOpen(false)}
            className="cancel-btn"
            disabled={processing}
          >
            Cancel
          </button>

          <button
            onClick={handleSaveCard}
            className="save-btn"
            disabled={processing || loading}
          >
            {processing ? "Saving..." : "Save Card"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCard;
